<template>
  <div class="page-container page-terms">
    <div class="h2 page-title">Termos de uso do sistema Stenci</div>
    <terms-content />
  </div>
</template>

<script>
import TermsContent from '@/components/terms/TermsContent.vue';

export default {
  components: {
    TermsContent,
  },
};
</script>

<style lang="scss">
  @import '@/assets/scss/_variables.scss';

  .page-terms {
    max-width: $control-width-lg;
    .page-title {
      font-size: $unit-10;
    }
  }
</style>
